module.exports = __webpack_public_path__ + "img/0-02-0a-9f17252855e38146fa24fbe67650e084efdf2de671d93fde07151d8a91aa9c8b_e23cfa3f.63f61baf.jpg";